const DECIMAL_TOLERANCE = 1e-6;

// toPrecision strips binary float noise before rounding, so 1.005 rounds up to 1.01.
export function roundTo2(value: number): number {
  return Math.round(Number((value * 100).toPrecision(12))) / 100;
}

export function isSameDecimal(left: number, right: number): boolean {
  return Math.abs(left - right) < DECIMAL_TOLERANCE;
}
